import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceAppsEditRoute } from '@/pages/workspaces/settings/actions/apps/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/apps/edit/$appId')({
  component: WorkspaceAppsEditRoute,
});
